import { render } from "./CustomConfirm.vue?vue&type=template&id=22cf34d7"
import script from "./CustomConfirm.vue?vue&type=script&lang=js"
export * from "./CustomConfirm.vue?vue&type=script&lang=js"

import "./CustomConfirm.vue?vue&type=style&index=0&id=22cf34d7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__